import React, { useState } from "react";
import Button from "../button/Button";

const YearPicker = ({ field = null, name, value, future=false, onChange }) => {

    const fieldName = name || field?.name || "";
    
    const currentYear = new Date().getFullYear();

    const [yearRange, setYearRange] = useState(
        Array.from({ length: 12 }, (_, i) => (value || currentYear) - 5 + i)
    );

    const handlePrevYears = () => {
        const firstYear = yearRange[0];
        const newRange = Array.from({ length: 12 }, (_, i) => firstYear - 12 + i);
        setYearRange(newRange);
    };

    const handleNextYears = () => {
        const lastYear = yearRange[yearRange.length - 1];
        const newRange = Array.from({ length: 12 }, (_, i) => lastYear + 1 + i);
        setYearRange(newRange);
    };

    const handleYearSelect = (year) => {
        const dropdownElementList = document.querySelectorAll('.year-dropdown');
        [...dropdownElementList].forEach(dropdownToggleEl => { new window.bootstrap.Dropdown(dropdownToggleEl).toggle()});
        onChange({target: {value: year}}, fieldName, year)
    };

    const enableFuture = (year) => {
        if(year <= currentYear) return true;
        return (year >= currentYear) && future;
    }

    return (
        <div className="input-group position-relative">
            <input type="number" value={value} readOnly className="form-control" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside" />
            <Button className="year-dropdown dropdown-toggle border px-2 rounded-end after-d-none" type="button"><i className="bi bi-calendar4-week"></i></Button>
            <div className="dropdown-menu container border p-3 rounded">
                <div className="d-flex justify-content-between align-items-center">
                    <Button primary small outline onClick={handlePrevYears} >
                        <i className="bi bi-chevron-double-left"></i> Prev
                    </Button>
                    <span className="text-center mb-0">Select a Year</span>
                    <Button primary small outline onClick={handleNextYears} >
                        Next <i className="bi bi-chevron-double-right"></i>
                    </Button>
                </div>
                <div className="row row-cols-4 g-2 mt-3">
                    {yearRange.map((year) => (
                        <div className="col" key={year}>
                            <Button
                                small
                                solid={year === value}
                                outline={year !== value}
                                className="w-100 fw-light"
                                primary={year === value}
                                secondary={year !== value}
                                onClick={() => handleYearSelect(year)}
                                disabled={!enableFuture(year)}
                            >
                                {year}
                            </Button>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default YearPicker;
